export default {
  getLang: state => state.lang,
  getInit: state => state.init,
  getMenu: state => state.menu,
  getMenuTrans: state => state.menuTrans,
  getTransName: state => state.transName,
  getRouteName: state => state.routeName,
  getNext: state => state.next,
  getPrev: state => state.prev,
  getIsTrans: state => state.isTrans,
  getGoHome: state => state.goHome,
  getFormStatus: state => state.formStatus,
  getPeopleId: state => state.peopleId,
};
